import { IServerSideDatasource, IServerSideGetRowsParams } from "@ag-grid-community/core";

import IFieldModel from "@mapmycustomers/shared/types/fieldModel/IFieldModel";
import ListRequest from "@mapmycustomers/shared/types/viewModel/internalModel/ListRequest";

import ListViewDataFetcher from "@app/types/viewModel/ListViewDataFetcher";
import convertFromAgGridColumnModel from "@app/util/viewModel/convertFromAgGridColumnModel";
import convertFromAgGridFilterModel from "@app/util/viewModel/convertFromAgGridFilterModel";
import { convertFromAgGridSortModel } from "@app/util/viewModel/convertSort";

class PlatformDataSource<T> implements IServerSideDatasource {
  private readonly fetcher: ListViewDataFetcher<T>;
  private readonly fieldModel: IFieldModel;

  constructor(fetcher: ListViewDataFetcher<T>, fieldModel: IFieldModel) {
    this.fetcher = fetcher;
    this.fieldModel = fieldModel;
  }

  destroy(): void {}

  getRows(params: IServerSideGetRowsParams): void {
    const request: Partial<ListRequest> = {
      columns: convertFromAgGridColumnModel(params.columnApi.getColumnState(), this.fieldModel),
      filter: convertFromAgGridFilterModel(params.request.filterModel, this.fieldModel),
      range: {
        endRow: params.request.endRow,
        startRow: params.request.startRow,
      },
      sort: convertFromAgGridSortModel(params.request.sortModel, this.fieldModel),
    };
    this.fetcher(
      request,
      (response) => {
        params.successCallback(response.data, response.total);
      },
      params.failCallback
    );
  }
}

export default PlatformDataSource;
